import { FormControl, FormGroup } from '@angular/forms';

import { SelectableElement } from '@interfaces/selectable-element';

type ModelType<T> = Partial<T> & { id: number };

export type SelectElementFormType<T> = {
  id: FormControl<number | null | undefined>;
  selected: FormControl<boolean>;
  _data: FormControl<ModelType<T> | undefined>;
};

export class SelectElementForm<T extends SelectableElement = any> extends FormGroup<SelectElementFormType<T>> {
  get id(): FormControl<number | null | undefined> {
    return this.controls.id;
  }

  get selected(): FormControl<boolean> {
    return this.controls.selected;
  }

  get data(): ModelType<T> | undefined {
    return this.controls._data.value;
  }

  constructor() {
    super({
      id: new FormControl<number | null | undefined>(undefined),
      selected: new FormControl<boolean>(false),
      _data: new FormControl<ModelType<T> | undefined>(undefined)
    });
  }

  fromValue(value: Partial<T> & { selected: boolean }): void {
    const { id, selected, ..._data } = value;
    this.patchValue({
      id,
      selected,
      _data: {
        ..._data,
        id
      } as ModelType<T>
    });
  }
}
